import { render, staticRenderFns } from "./right-sidebar.vue?vue&type=template&id=2cffb683&scoped=true&"
import script from "./right-sidebar.vue?vue&type=script&lang=js&"
export * from "./right-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./right-sidebar.vue?vue&type=style&index=0&id=2cffb683&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cffb683",
  null
  
)

export default component.exports